export const PHONE_PATTERN = /^\d{10}$/;
export const ZIP_PATTERN = /^\d{5}$/;
export const BIN_PATTERN = /^\d{6}$/;
export const NPI_PATTERN = /^\d{10}$/;
export const EMAIL_PATTERN = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

export const filled = (value) => String(value ?? "").trim() !== "";

export const isValidOrBlank = (pattern, value) => {
    const raw = String(value ?? "").trim();
    if (raw === "") return true;
    return pattern.test(raw.replace(/\D/g, ""));
};


